import { secondsToMinutesAndSeconds } from 'helpers/common';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const timerDuration = 30; // 30 seconds - 0.5 minutes
const OTPTimer = ({ onResend }) => {
  const [timeLeft, setTimeLeft] = useState(timerDuration);
  const [isTimerRunning, setTimeRunning] = useState(true);
  const [resendingOtp, setResendingOtp] = useState(false);

  const { minutes, seconds } = secondsToMinutesAndSeconds(timeLeft);

  useEffect(() => {
    let interval;
    if(isTimerRunning) {
      interval = setInterval(() => {
        setTimeLeft(prevTime => {
          if(timeLeft === 0) {
            setTimeRunning(false);
            setTimeLeft(0);
            return 0;
          } else {
            return prevTime - 1;
          }
        })
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    }
  }, [])

  const restartTimer = () => {
    setTimeLeft(timerDuration);
    setTimeRunning(true);
  }

  const handleClickResend = async () => {
    try {
      setResendingOtp(true);
      await onResend(restartTimer);
    } finally {
      setResendingOtp(false);
    }
  }

  return (
    <div className="resend-otp-timer">
      {(isTimerRunning && timeLeft > 0) ? (
        <p className='m-0'>
          Resend OTP in {minutes}:{seconds < 10 ? `0${seconds}` : seconds}{' '}
          seconds
        </p>
      ):(
        <Link
          onClick={handleClickResend}
        >
          {resendingOtp ? "Please wait..." : "Resend OTP"}
        </Link>
      )}
    </div>
  )
};

export default OTPTimer;